import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { TrendingUp } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", business_name: "" });
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await register(form);
    setLoading(false);
    if (ok) nav("/");
  };

  return (
    <div className="min-h-screen bg-[#0B0F17] text-slate-100 flex items-center justify-center p-6 grain-bg">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 mb-8">
          <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-indigo-500 to-fuchsia-500 flex items-center justify-center">
            <TrendingUp className="w-5 h-5 text-white" />
          </div>
          <div className="font-display font-extrabold text-lg">Finakış</div>
        </div>

        <div className="text-[10px] uppercase tracking-[0.3em] text-indigo-400 mb-2">Hesap Oluştur</div>
        <h2 className="font-display text-3xl font-bold tracking-tight mb-2">Finakış&apos;a başlayın</h2>
        <p className="text-sm text-slate-400 mb-8">İşletmenizin finansal takibine saniyeler içinde başlayın.</p>

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <Label className="text-xs uppercase tracking-wider text-slate-400">Ad Soyad</Label>
            <Input
              required
              value={form.name}
              onChange={update("name")}
              data-testid="register-name-input"
              className="mt-2 bg-[#131924] border-white/10 h-11"
            />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider text-slate-400">İşletme / Freelance Adı (opsiyonel)</Label>
            <Input
              value={form.business_name}
              onChange={update("business_name")}
              data-testid="register-business-input"
              className="mt-2 bg-[#131924] border-white/10 h-11"
            />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider text-slate-400">E-posta</Label>
            <Input
              required
              type="email"
              value={form.email}
              onChange={update("email")}
              data-testid="register-email-input"
              className="mt-2 bg-[#131924] border-white/10 h-11"
            />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider text-slate-400">Şifre (en az 6 karakter)</Label>
            <Input
              required
              type="password"
              minLength={6}
              value={form.password}
              onChange={update("password")}
              data-testid="register-password-input"
              className="mt-2 bg-[#131924] border-white/10 h-11"
            />
          </div>

          <Button
            type="submit"
            disabled={loading}
            data-testid="register-submit-button"
            className="w-full h-11 bg-indigo-500 hover:bg-indigo-600 font-semibold"
          >
            {loading ? "Oluşturuluyor..." : "Hesap Oluştur"}
          </Button>

          <div className="text-center text-sm text-slate-500">
            Zaten hesabınız var mı?{" "}
            <Link to="/login" data-testid="login-link" className="text-indigo-400 hover:text-indigo-300 font-medium">
              Giriş Yap
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
